import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  title: "",
};

const breadcrumbsSlice = createSlice({
  name: "breadcrumbs",
  initialState,
  reducers: {
    setBreadcrumbs: (state, { payload }) => {
      state.title = payload.title;
    },
  },
});

export const { setBreadcrumbs } = breadcrumbsSlice.actions;
export default breadcrumbsSlice.reducer;
